export default __webpack_public_path__ + "static/media/left-arrow--white-2.e516064e.svg";